export function DashboardTransactionsCtrl (
  $scope,
  $state,
  $translate,
  messages,
  workshopAPI
) {

  $scope.tableSettings = {
    columns: [
      {
        field : 'username',
        header: {
          text: $translate.instant('COMPANY_SPACE.USERS.USER')
        }
      },
      {
        field : 'transaction_note',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.TRANSACTION')
        }
      },
      {
        field : 'transaction_time',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'globalDate'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_TRANSACTIONS')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10 ],
      queryCount: () => workshopAPI.get('/dashboard/transaction_logs_count')
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.getTransactions = ( params ) => {
    return workshopAPI.get('/dashboard/transaction_logs_index', [
      params.pageSize,
      params.offset,
    ])
    .then(transactions => {
      $scope.transactions = transactions;

      return transactions;
    }).then(transactions => {
      $scope.transactions = transactions;

      return transactions;
    });
  };

  $scope.refresh = function () {
    $state.reload();

    messages.show($translate.instant('JS_SPACE.MESSAGES.REFRESHED'), 'success');
  };
}